import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import WhatsAppButton from '../../components/ui/WhatsAppButton';
import HeroSection from './components/HeroSection';
import ArticleGrid from './components/ArticleGrid';
import Newsletter from './components/Newsletter';
import CTASection from './components/CTASection';

const BlogHub = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-16">
        <HeroSection />
        <ArticleGrid />
        <Newsletter />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default BlogHub;